import { useState } from "react";

export interface INicknameSettingsStorageState {
  noNicknames: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type LocalStorageStateSetter = (key: keyof INicknameSettingsStorageState, value: any) => void;

// declares variables that will be saved on local storage
// INFO: if more field are added, this shoud be converted to a ZOD schema to verify the schema before `JSON.parse` & `JSON.stringify`
export const outbidLocalStorageState: INicknameSettingsStorageState = {
  noNicknames: false,
};

export function useOutbidLocalStorageState(): [INicknameSettingsStorageState, LocalStorageStateSetter] {
  const [state, setState] = useState<INicknameSettingsStorageState>(
    localStorage.getItem("outbidLocalStorageState") && localStorage.getItem("outbidLocalStorageState") !== ""
      ? JSON.parse(localStorage.getItem("outbidLocalStorageState"))
      : outbidLocalStorageState
  );

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function setStorage(key: keyof INicknameSettingsStorageState, value: any) {
    const updatedState = { ...state, [key]: value };
    localStorage.setItem("outbidLocalStorageState", JSON.stringify(updatedState));
    setState(updatedState);
  }

  return [state, setStorage];
}
